import { TutorialStep } from 'src/replicant/tutorial/tutorial.ruleset';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';

export class DuoInviteReceivedTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'duoInviteReceived';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    if (event !== 'duoInvitationReceived') return false;

    await showTutorial('duoInviteReceived', {
      $stepIndex: 15,
      $stepName: 'duo_invite_received',
    });

    return true;
  }
}
